import { c as _c } from "react/compiler-runtime";
import type { DonationBusinessesApiDto } from '__generated__/api/unauth/types.gen';
import { Fragment } from 'react';
import { SearchCategoryAdSlot } from '@/app/_components/ads';
import { SearchEmptyResults } from '../SearchEmptyResults';
import { SearchDonationCard } from './SearchDonationCard';
export function DonationBusinessList(t0) {
  const $ = _c(7);
  const {
    items
  } = t0;
  if (items.length < 1) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SearchEmptyResults />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== items) {
    let t2;
    if ($[3] !== items.length) {
      t2 = (item, idx) => <Fragment key={item.donationBusinessId}><SearchCategoryAdSlot as="li" placement="search-donation-business" position={idx + 1} listLength={items.length} /><li><SearchDonationCard businessId={item.donationBusinessId ?? 0} slugId={item.slugId} thumbnailUrl={item.thumbnailUrl ?? ""} title={item.donationBusinessName ?? ""} institutionName={item.institutionName ?? ""} endDate={item.endDate} donationAmount={Math.max((item.goalAmt ?? 0) - (item.rmAmt ?? 0), 0)} achievementRate={item.achievementRate ?? 0} isEnded={item.specificDonationStatus === "ENDED"} /></li></Fragment>;
      $[3] = items.length;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = items.map(t2);
    $[1] = items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <ul className="flex flex-col gap-20 pb-40 mobile-tablet:gap-16 mobile-tablet:px-20">{t1}</ul>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}